import { render, staticRenderFns } from "./ExamStructureProperties.vue?vue&type=template&id=a6c73044&"
import script from "./ExamStructureProperties.vue?vue&type=script&lang=js&"
export * from "./ExamStructureProperties.vue?vue&type=script&lang=js&"
import style0 from "./ExamStructureProperties.vue?vue&type=style&index=0&id=a6c73044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports